import { render } from "./dialogConfirmByPass.vue?vue&type=template&id=6ff2dd07&scoped=true"
import script from "./dialogConfirmByPass.vue?vue&type=script&lang=js"
export * from "./dialogConfirmByPass.vue?vue&type=script&lang=js"

import "./dialogConfirmByPass.vue?vue&type=style&index=0&id=6ff2dd07&scoped=true&lang=css"

import exportComponent from "/Users/charcoaldev/Documents/GitHub/beardrug-pos/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff2dd07"]])

export default __exports__